import { createContext, useContext, useState, useCallback } from 'react';
import { apiAdminLogout } from '../api/adminApi';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  // 토큰 대신 로그인 여부 플래그만 sessionStorage에 저장 (탭 닫으면 소멸)
  // 실제 인증은 httpOnly 쿠키가 담당
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(
    () => sessionStorage.getItem('adminLoggedIn') === 'true'
  );

  const adminLogin = useCallback(() => {
    sessionStorage.setItem('adminLoggedIn', 'true');
    setIsAdminLoggedIn(true);
  }, []);

  const adminLogout = useCallback(async () => {
    sessionStorage.removeItem('adminLoggedIn');
    setIsAdminLoggedIn(false);
    await apiAdminLogout();
  }, []);

  return (
    <AdminAuthContext.Provider value={{ isAdminLoggedIn, adminLogin, adminLogout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
}
